// Country flags for the Supply Chain Chronology sections, backed by
// country-flag-icons (accurate 3x2 SVG components for every ISO 3166-1 alpha-2
// code). Lookup is by ISO2 — which the backend already supplies for COO / API /
// labeller nodes and for every BOL partner row. Unknown or blank codes fall
// back to a neutral placeholder so the layout never breaks.
import React from 'react';
import * as CountryFlags from 'country-flag-icons/react/3x2';

type FlagComponent = React.ComponentType<React.SVGProps<SVGSVGElement> & { title?: string }>;
const FLAG_COMPONENTS = CountryFlags as unknown as Record<string, FlagComponent>;

export function Flag({ iso, bordered = true }: { iso?: string | null; bordered?: boolean }): React.ReactElement {
  const key = (iso || '').trim().toUpperCase();
  const Cmp = key ? FLAG_COMPONENTS[key] : undefined;

  const inner = Cmp ? (
    <span style={{ width: 30, height: 20, borderRadius: 2, overflow: 'hidden', display: 'block' }}>
      <Cmp title={key} style={{ width: '100%', height: '100%', display: 'block' }} />
    </span>
  ) : (
    <span style={{ width: 30, height: 20, background: '#D4CFC6', borderRadius: 2, display: 'block' }} />
  );

  if (!bordered) return inner;
  return (
    <span style={{ padding: 2, border: '1px solid #D4CFC6', borderRadius: 3, display: 'inline-block', lineHeight: 0 }}>
      {inner}
    </span>
  );
}
